import React from 'react';
import { AuthWrapper } from '../../../_uiComponents/common/AuthWrapper';
import ResetPassword from './forms/ResetPassword';

function ResetPasswordWrapper() {
  return (
    <>
     <AuthWrapper heading="Reset Password">
        <ResetPassword/>
     </AuthWrapper>
    </>
  )
}

export default ResetPasswordWrapper